<template>

				<button @click="openModal"
					class="flex flex-col items-center justify-center gap-0.5 text-gray-400 active:text-gray-600 transition-colors w-full">
					<svg class="w-[22px] h-[22px]" fill="none" stroke="currentColor" stroke-width="1.75" viewBox="0 0 24 24">
						<path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6A2.25 2.25 0 0 1 6 3.75h2.25A2.25 2.25 0 0 1 10.5 6v2.25a2.25 2.25 0 0 1-2.25 2.25H6a2.25 2.25 0 0 1-2.25-2.25V6ZM3.75 15.75A2.25 2.25 0 0 1 6 13.5h2.25a2.25 2.25 0 0 1 2.25 2.25V18a2.25 2.25 0 0 1-2.25 2.25H6A2.25 2.25 0 0 1 3.75 18v-2.25ZM13.5 6a2.25 2.25 0 0 1 2.25-2.25H18A2.25 2.25 0 0 1 20.25 6v2.25A2.25 2.25 0 0 1 18 10.5h-2.25a2.25 2.25 0 0 1-2.25-2.25V6ZM13.5 15.75a2.25 2.25 0 0 1 2.25-2.25H18a2.25 2.25 0 0 1 2.25 2.25V18A2.25 2.25 0 0 1 18 20.25h-2.25A2.25 2.25 0 0 1 13.5 18v-2.25Z"/>
					</svg>
					<span class="text-[10px] font-medium">More</span>
				</button>
				<Transition name="slide-bottom" appear>
					<div v-if="isModalOpen" class="z-50 bottom-0 fixed w-full left-0 md:hidden">
						<div class="bg-white w-full rounded-t-2xl overflow-hidden shadow-2xl" style="padding-bottom: env(safe-area-inset-bottom)">
							<!-- Drag handle + close -->
							<button @click="openModal" class="w-full flex flex-col items-center pt-3 pb-2">
								<span class="w-10 h-1 rounded-full bg-gray-300"></span>
							</button>
							<p class="text-center text-[11px] font-semibold uppercase tracking-widest text-gray-400 pb-3">More</p>
							<div class="border-t border-gray-100"></div>
							<ul class="py-3 text-sm grid grid-cols-3 text-gray-700">
								<li>
									<router-link @click="openModal"
										:class="{'fill-blue-600 font-medium bg-transparent text-blue-600' : linkIsActive('events')}"
										class="flex flex-col items-center px-2 py-4 hover:bg-gray-50 active:bg-gray-100"
										:to="{ name: 'OrganizationEvents', params: { url: orgStoreObj().current_org.url } }" v-slot="{ navigate }">
										<span class="mb-1">
											<svg class="h-5 w-5"
												:class="{'fill-blue-600' : linkIsActive('events'), 'fill-gray-900 dark:fill-gray-200' : !linkIsActive('events')}"
												xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
												<path
													d="M20 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM4 19V5h7v14H4zm9 0V5h7l.001 14H13z">
												</path>
												<path d="M15 7h3v2h-3zm0 4h3v2h-3z"></path>
											</svg>
										</span>
				
										<span>{{ I18N.application.index.events }}</span>
									</router-link>
								</li>
								<li>
									<router-link @click="openModal"
										:class="{'fill-blue-600 font-medium bg-transparent text-blue-600' : linkIsActive('bookings')}"
										class="flex flex-col items-center px-2 py-4 hover:bg-gray-50 active:bg-gray-100"
										:to="{ name: 'OrganizationBookings', params: { url: orgStoreObj().current_org.url } }"
										v-slot="{ navigate }">
										<span class="mb-1">
											<svg class="h-5 w-5"
												:class="linkIsActive('bookings') ? 'fill-blue-600' : 'fill-gray-900 dark:fill-gray-200'"
												xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
												<path
													d="M19 4h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm.002 16H5V8h14l.002 12z">
												</path>
												<path d="m11 17.414 5.707-5.707-1.414-1.414L11 14.586l-2.293-2.293-1.414 1.414z"></path>
											</svg>
										</span>
				
										<span>{{ I18N.application.index.bookings }}</span>
									</router-link>
								</li>
								<li>
									<router-link @click="openModal"
										:class="{'fill-blue-600 font-medium bg-transparent text-blue-600' : linkIsActive('notifications')}"
										class="flex flex-col items-center px-2 py-4 hover:bg-gray-50 active:bg-gray-100"
										:to="{ name: 'OrganizationNotification', params: { url: orgStoreObj().current_org.url } }"
										v-slot="{ navigate }">
										<span class="mb-1">
											<svg class="h-5 w-5"
												:class="linkIsActive('notifications') ? 'fill-blue-600' : 'fill-gray-900 dark:fill-gray-200'"
												xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" focusable="false">
												<path
													d="M22 19h-8.28a2 2 0 11-3.44 0H2v-1a4.52 4.52 0 011.17-2.83l1-1.17h15.7l1 1.17A4.42 4.42 0 0122 18zM18.21 7.44A6.27 6.27 0 0012 2a6.27 6.27 0 00-6.21 5.44L5 13h14z">
												</path>
											</svg>
										</span>
				
										<span>{{ I18N.notifications.title }}</span>
									</router-link>
								</li>
								<li>
									<router-link @click="openModal"
										:class="{'fill-blue-600 font-medium bg-transparent text-blue-600' : linkIsActive('settings')}"
										class="flex flex-col items-center px-2 py-4 hover:bg-gray-50 active:bg-gray-100"
										:to="'/organizations/' + orgStoreObj().current_org.url + '/profile'" v-slot="{ navigate }">
										<span class="mb-1">
											<svg class="h-5 w-5"
												:class="linkIsActive('settings') ? 'fill-blue-600' : 'fill-gray-900 dark:fill-gray-200'"
												xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
												<path
													d="M12 16c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4zm0-6c1.084 0 2 .916 2 2s-.916 2-2 2-2-.916-2-2 .916-2 2-2z">
												</path>
												<path
													d="m2.845 16.136 1 1.73c.531.917 1.809 1.261 2.73.73l.529-.306A8.1 8.1 0 0 0 9 19.402V20c0 1.103.897 2 2 2h2c1.103 0 2-.897 2-2v-.598a8.132 8.132 0 0 0 1.896-1.111l.529.306c.923.53 2.198.188 2.731-.731l.999-1.729a2.001 2.001 0 0 0-.731-2.732l-.505-.292a7.718 7.718 0 0 0 0-2.224l.505-.292a2.002 2.002 0 0 0 .731-2.732l-.999-1.729c-.531-.92-1.808-1.265-2.731-.732l-.529.306A8.1 8.1 0 0 0 15 4.598V4c0-1.103-.897-2-2-2h-2c-1.103 0-2 .897-2 2v.598a8.132 8.132 0 0 0-1.896 1.111l-.529-.306c-.924-.531-2.2-.187-2.731.732l-.999 1.729a2.001 2.001 0 0 0 .731 2.732l.505.292a7.683 7.683 0 0 0 0 2.223l-.505.292a2.003 2.003 0 0 0-.731 2.733zm3.326-2.758A5.703 5.703 0 0 1 6 12c0-.462.058-.926.17-1.378a.999.999 0 0 0-.47-1.108l-1.123-.65.998-1.729 1.145.662a.997.997 0 0 0 1.188-.142 6.071 6.071 0 0 1 2.384-1.399A1 1 0 0 0 11 5.3V4h2v1.3a1 1 0 0 0 .708.956 6.083 6.083 0 0 1 2.384 1.399.999.999 0 0 0 1.188.142l1.144-.661 1 1.729-1.124.649a1 1 0 0 0-.47 1.108c.112.452.17.916.17 1.378 0 .461-.058.925-.171 1.378a1 1 0 0 0 .471 1.108l1.123.649-.998 1.729-1.145-.661a.996.996 0 0 0-1.188.142 6.071 6.071 0 0 1-2.384 1.399A1 1 0 0 0 13 18.7l.002 1.3H11v-1.3a1 1 0 0 0-.708-.956 6.083 6.083 0 0 1-2.384-1.399.992.992 0 0 0-1.188-.141l-1.144.662-1-1.729 1.124-.651a1 1 0 0 0 .471-1.108z">
												</path>
											</svg>
										</span>
				
										<span>{{ I18N.application.events.settings }}</span>
									</router-link>
								</li>
								<li>
									<a @click="openModal" href="/attendees"
										:class="{'fill-blue-600 font-medium bg-transparent text-blue-600' : current_route == 'attendees_index'}"
										class="flex flex-col items-center px-2 py-4 hover:bg-gray-50 active:bg-gray-100 ">
										<span class="mb-1">
											<svg class="h-5 w-5"
												:class="{'fill-blue-600' : current_route == 'attendees_index' , 'fill-gray-900 dark:fill-gray-200' :current_route != 'attendees_index' }"
												viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
												<path
													d="M729.6 560c-80 0-147.2-64-147.2-147.2s64-147.2 147.2-147.2 147.2 64 147.2 147.2-67.2 147.2-147.2 147.2z m0-230.4c-44.8 0-83.2 35.2-83.2 83.2s35.2 83.2 83.2 83.2 83.2-35.2 83.2-83.2-38.4-83.2-83.2-83.2zM947.2 889.6h-134.4c-19.2 0-32-12.8-32-32s12.8-32 32-32h131.2c-3.2-70.4-73.6-172.8-176-172.8h-12.8c-19.2 0-32-12.8-32-32s12.8-32 32-32h12.8c147.2 0 240 144 240 240 0 35.2-28.8 60.8-60.8 60.8z" />
												<path
													d="M377.6 499.2C275.2 499.2 192 416 192 316.8s83.2-182.4 182.4-182.4 182.4 83.2 182.4 182.4-80 182.4-179.2 182.4z m0-300.8C310.4 198.4 256 249.6 256 316.8s54.4 118.4 118.4 118.4 118.4-54.4 118.4-118.4-51.2-118.4-115.2-118.4zM665.6 889.6H86.4c-38.4 0-70.4-32-70.4-70.4 0-124.8 121.6-307.2 307.2-307.2h99.2c188.8 0 307.2 182.4 307.2 307.2 6.4 38.4-25.6 70.4-64 70.4zM326.4 576c-147.2 0-243.2 147.2-243.2 243.2 0 3.2 3.2 6.4 6.4 6.4h579.2c3.2 0 6.4-3.2 6.4-6.4 0-96-96-243.2-243.2-243.2h-105.6z" />
											</svg>
										</span>
				
										<span>{{ I18N.website_content.app_nav.attendees }}</span>
									</a>
								</li>
				
								<li>
									<router-link @click="openModal"
										:class="{'fill-blue-600 font-medium bg-transparent text-blue-600' : linkIsActive('analytics')}"
										class="flex flex-col items-center px-2 py-4 hover:bg-gray-50 active:bg-gray-100"
										:to="{ name: 'OrganizationAnalytics', params: { url: orgStoreObj().current_org.url } }"
										v-slot="{ navigate }">
										<span class="mb-1">
											<svg class="h-[18px] w-[18px]"
												:class="linkIsActive('analytics') ? 'fill-blue-600' : 'fill-gray-900 dark:fill-gray-200'"
												xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
												<path
													d="M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32zm96 96c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32zm32 64H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 96H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32z" />
											</svg>
										</span>
				
										<span>{{ I18N.website_content.app_nav.analytics }}</span>
									</router-link>
								</li>
								<li>
									<a @click="openModal" href="/integrations"
										:class="{'fill-blue-600 font-medium bg-transparent text-blue-600' : current_route == 'integrations_index'}"
										class="flex flex-col items-center px-2 py-4 hover:bg-gray-50 active:bg-gray-100 ">
										<span class="mb-1">
											<svg class="h-5 w-5"
												:class="{'fill-blue-600' : current_route == 'integrations_index' , 'fill-gray-900 dark:fill-gray-200' :current_route != 'integrations_index' }"
												xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
												<path
													d="M4.222 19.778a4.983 4.983 0 0 0 3.535 1.462 4.986 4.986 0 0 0 3.536-1.462l2.828-2.829-1.414-1.414-2.828 2.829a3.007 3.007 0 0 1-4.243 0 3.005 3.005 0 0 1 0-4.243l2.829-2.828-1.414-1.414-2.829 2.828a5.006 5.006 0 0 0 0 7.071zm15.556-8.485a5.008 5.008 0 0 0 0-7.071 5.006 5.006 0 0 0-7.071 0L9.879 7.051l1.414 1.414 2.828-2.829a3.007 3.007 0 0 1 4.243 0 3.005 3.005 0 0 1 0 4.243l-2.829 2.828 1.414 1.414 2.829-2.828z">
												</path>
												<path d="m8.464 16.95-1.415-1.414 8.487-8.486 1.414 1.415z"></path>
											</svg>
										</span>
										<span>
											{{ I18N.application.integrations.title }}
										</span>
									</a>
								</li>
								<li>
									<router-link @click="openModal"
										:class="{'fill-blue-600 font-medium bg-transparent text-blue-600' : linkIsActive('availabilities')}"
										class="flex flex-col items-center px-2 py-4 hover:bg-gray-50 active:bg-gray-100"
										:to="{ name: 'OrganizationAvailabilities', params: { url: orgStoreObj().current_org.url } }"
										v-slot="{ navigate }">
										<span class="mb-1"><svg class="h-5 w-5"
												:class="linkIsActive('availabilities') ? 'fill-blue-600' : 'fill-gray-900 dark:fill-gray-200'"
												xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
												<path
													d="M128 0c13.3 0 24 10.7 24 24V64H296V24c0-13.3 10.7-24 24-24s24 10.7 24 24V64h40c35.3 0 64 28.7 64 64v16 48V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192 144 128C0 92.7 28.7 64 64 64h40V24c0-13.3 10.7-24 24-24zM400 192H48V448c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V192zM329 297L217 409c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 95-95c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z" />
											</svg></span>
				
										<span>
											{{ I18N.website_content.app_nav.availabilities}}
										</span>
									</router-link>
								</li>
				
								<li>
									<a @click="openModal" href="/holidays"
										:class="{'fill-blue-600 font-medium bg-transparent text-blue-600' : current_route == 'holidays_index'}"
										class="flex flex-col items-center px-2 py-4 hover:bg-gray-50 active:bg-gray-100 ">
										<span class="mb-1"><svg class="h-5 w-5"
												:class="{'fill-blue-600' : current_route == 'holidays_index' , 'fill-gray-900 dark:fill-gray-200' : current_route != 'holidays_index' }"
												xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
												<path
													d="M18 8.31c-.36-.41-.73-.82-1.12-1.21l-.29-.27.14-.12a3.15 3.15 0 0 0 .9-3.49A3.91 3.91 0 0 0 14 1v2a2 2 0 0 1 1.76 1c.17.4 0 .84-.47 1.31-.07.08-.15.13-.22.2-3-2.41-6.29-3.77-7.9-2.16a2.16 2.16 0 0 0-.41.59v.1l-.18.53-4.41 13.1A3.28 3.28 0 0 0 5.28 22a3.21 3.21 0 0 0 1-.17L20 17.28a1 1 0 0 0 .43-.31l.21-.18c1.43-1.44.51-4.21-1.41-6.9A6.63 6.63 0 0 1 23 9V7a8.44 8.44 0 0 0-5 1.31zM5.7 19.93a1.29 1.29 0 0 1-1.63-1.63l1.36-4.1a10.7 10.7 0 0 0 4.29 4.39zm7-2.33a8.87 8.87 0 0 1-6.3-6.29l1-3 .06.09c.11.22.25.45.39.68s.16.29.26.44.33.48.51.73.19.28.3.42.43.55.66.82l.29.35c.34.39.7.77 1.08 1.16s.68.64 1 1l.33.28.78.63.37.28c.28.2.55.4.83.58l.31.2c.36.22.72.43 1.07.61h.05zm6.51-2.23h-.06c-.69.38-3.56-.57-6.79-3.81-.34-.34-.66-.67-.95-1l-.29-.35-.53-.64-.29-.4c-.13-.19-.27-.37-.39-.55l-.26-.42-.29-.47c-.08-.14-.14-.27-.21-.4s-.15-.26-.21-.4a3.31 3.31 0 0 1-.14-.36c-.05-.13-.11-.26-.15-.38S8.6 6 8.57 5.88s-.05-.22-.07-.32a2.26 2.26 0 0 1 0-.26 1 1 0 0 1 0-.24l.11-.31c.36-.36 2.23 0 4.73 1.9A4.13 4.13 0 0 1 12 7v2a6.45 6.45 0 0 0 3-.94l.48.46c.42.42.81.85 1.18 1.28a5.32 5.32 0 0 0-.6 3.4l2-.39a3.57 3.57 0 0 1 0-1.12 11.3 11.3 0 0 1 .81 1.45c.56 1.32.52 2.06.34 2.23z">
												</path>
											</svg></span>
										<span>{{ I18N.website_content.app_nav.holidays }}</span>
									</a>
								</li>
								<li>
									<a @click="openModal" href="/connected_calendars"
										:class="{'fill-blue-600 font-medium bg-transparent text-blue-600' : current_route == 'connected_calendars_index'}"
										class="flex flex-col items-center px-2 py-4 hover:bg-gray-50 active:bg-gray-100 ">
										<span class="mb-1"><svg class="h-5 w-5"
												:class="{'fill-blue-600' : current_route == 'connected_calendars_index' , 'fill-gray-900 dark:fill-gray-200' : current_route != 'connected_calendars_index' }"
												xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
												<path d="M8 13h8v2H8z"></path>
												<path
													d="M19 4h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm.002 16H5V8h14l.002 12z">
												</path>
											</svg></span>
				
										<span class="text-center">{{ I18N.website_content.app_nav.connected_calendar }}</span>
									</a>
								</li>
							</ul>
						</div>
					</div>
				</Transition>
				<div v-show="backdropShow" @click="openModal" class="bg-black/50 backdrop-blur-sm fixed inset-0 z-20"></div>

    
</template>

<script>
import { orgStore } from "controllers/vue_components/organizations/store";
import Constants from "controllers/vue_components/mixins/constants";
export default {
  name: "TimelydoBottomModal",
  mixins: [Constants],
  props: ["current_route"],
  data() {
    return {
      isModalOpen: false,
      backdropShow: false,
    };
  },
  methods: {
    orgStoreObj() {
      return orgStore();
    },
    openModal() {
      this.isModalOpen = !this.isModalOpen;
      if (!this.isModalOpen) {
        setTimeout(() => {
          this.backdropShow = false;
        }, 800);
      } else {
        this.backdropShow = true;
      }
    },

    linkIsActive(link) {
      if (link == "settings") {
        const pages = ["profile", "account", "members", "plan", "developers"];
        return pages.includes(this.$route.path);
      } else {
        return this.$route.path.includes(link);
      }
    },
  },

  computed: {}

};
</script>
